import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M17.886 16l-1.74-4.306v-.001c-.19-.47-.454-.88-.784-1.221a6.655 6.655 0 0 0-1.97-1.385l-.375-.175-.297.289a3.659 3.659 0 0 1-1.869.984 6.45 6.45 0 0 1 .65 2.814c0 1.082-.27 2.102-.74 3h7.125zm-4.49-11.989C13.396 1.574 12.064 0 10.004 0c-2.07 0-3.408 1.574-3.408 4.011 0 2.085 1.054 4.188 3.408 4.188 2.33 0 3.392-2.171 3.392-4.188zM5 8a5 5 0 1 0 .001 10.001A5 5 0 0 0 5 8zm2.5 6.561l-1.75-1.75v2.79h-1.5v-2.79l-1.75 1.75V12.44L5 9.94l2.5 2.5v2.121z" />
  </svg>
);

export default SvgComponent;
